import { ItemMenu } from './Menu';

const controllerRoute = 'admin/';

export class T {
    public static _(str: string, domain: string): string {
        const T = (window as any).T as any;

        if (T) return T._(str, domain);
        else return str;
    }
}

const getRouteName = (url: string) => {
    const firstRouteChar = url.indexOf(controllerRoute) + controllerRoute.length;
    // const endRouteIndex = url.indexOf('/', firstRouteChar) > -1
    //     ? url.indexOf('/', firstRouteChar)
    //     : url.length;

    return url.substring(firstRouteChar, url.length);
};

// export const isMenuItemSelected = (item: ItemMenu) => {
// 	const currentUrl = window.location.href;
// 	const [, itemSearch] = item.urlPage.toLowerCase().split('?');

// 	// Remove culture and "/Admin"
// 	// let itemRoute = getRouteName(itemBaseUrl);
// 	let currentRoute = getRouteName(currentUrl.toLowerCase());

// 	// if (itemRoute.endsWith("dashboard") && (!currentBaseUrl || currentBaseUrl === "/")) return true;
// 	// if (!itemRoute.includes(currentRoute)) return false;

// 	if (!item.regex || !new RegExp(item.regex, 'i').test(currentRoute)) return false;

// 	const itemParams = new URLSearchParams(itemSearch);
// 	const currentParams = new URLSearchParams(currentUrl);

// 	for (let param of itemParams as unknown as Array<[string, string]>) {
// 		if (!currentParams.has(param[0]) || currentParams.get(param[0]) !== param[1]) return false;
// 	}

// 	return true;
// };

export const isMenuItemSelected = (item: ItemMenu) => {
    const currentRoute = getRouteName(window.location.href.toLowerCase());
    return Boolean(item.regex && new RegExp(item.regex, 'i').test(currentRoute));
};

export const isMenuKeySelected = (key?: string) => {
    if (!key) return false;

    const normalizedPath = window.location.pathname.toLowerCase().replace(/\/+$/, '');
    const currentRouteKey = normalizedPath.split('/').filter(Boolean).pop();

    return currentRouteKey === key.toLowerCase();
};

export const isMenuItemKeySelected = (item: ItemMenu) => isMenuKeySelected(item.key);

export const getCookie = (name: string) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match?.[2];
};

export const setCookie = (name: string, value: any, daysToLive: number) => {
    // Encode value in order to escape semicolons, commas, and whitespace
    var cookie = name + '=' + encodeURIComponent(value);
    /* Sets the max-age attribute so that the cookie expires
    after the specified number of days */
    cookie += ';max-age=' + daysToLive * 24 * 60 * 60 + ';path=/';
    document.cookie = cookie;
};
